import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-j02" }
const _hoisted_5 = { class: "p-the-page-j02__body" }
const _hoisted_6 = { class: "p-the-page-j02__body__icon" }
const _hoisted_7 = { class: "p-the-page-j02__body__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_theHeader = _resolveComponent("theHeader")!
  const _component_IconBalloons = _resolveComponent("IconBalloons")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_TheTemplateJ = _resolveComponent("TheTemplateJ")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_theHeader),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheTemplateJ, {
          heading: _ctx.thanksPointName2 + 'メッセージ',
          "indicated-item": ['button']
        }, {
          contents: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("i", _hoisted_6, [
                  _createVNode(_component_IconBalloons)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", null, [
                    _createVNode(_component_SmallText, { size: 14 }, {
                      default: _withCtx(() => [
                        _createTextVNode("仲間に" + _toDisplayString(_ctx.thanksPointName1) + "を贈ってみよう！", 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["heading"])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}